// Generated by CoffeeScript 1.12.6
(function() {
  var mixin, toaster;

  mixin = null;

  toaster = null;

  module.exports = function(theme) {
    if (!mixin) {
      if (!window.customElements.get("ceri-toaster")) {
        window.customElements.define("ceri-toaster", require("./toaster")(theme));
      }
      if (!toaster) {
        toaster = document.createElement("ceri-toaster");
        document.body.appendChild(toaster);
      }
      mixin = {
        _name: "toaster",
        _v: 1,
        methods: {
          $toast: function(o) {
            o.onClose = (function(_this) {
              return function() {
                var i;
                if (close && ~(i = _this._toasts.indexOf(close))) {
                  return _this._toasts.splice(i, 1);
                }
              };
            })(this);
            toaster.toast(o);
            this._toasts.push(o.close);
            return o.close;
          }
        },
        connectedCallback: function() {
          if (this._isFirstConnect) {
            return this._toasts = [];
          }
        },
        disconnectCallback: function() {
          var close, j, len, ref;
          ref = this._toasts;
          for (j = 0, len = ref.length; j < len; j++) {
            close = ref[j];
            close(true);
          }
          return this._toasts = [];
        }
      };
    }
    return mixin;
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-toaster/mixin.js
// module id = 64
// module chunks = 1